import styled, { css } from 'styled-components'
import media from 'styled-media-query'
import theme from '../../styles/theme'

type filterContentProps = {
  dropdownIsOpen: boolean
}

export const ButtonSearch = styled.button`
  background-color: ${theme.colors.primary};
  width: auto;
  display: flex;
  max-width: unset !important;
  flex-direction: row;
  align-items: center;
  position: absolute;
  padding: 0 25px;
  top: 0;
  right: 0;
  border-radius: 0 24px 24px 0;
  height: 48px;
  color: ${theme.colors.white};
  font-weight: 600;
  font-size: 15px;
  & > svg {
    top: 0 !important;
    left: 0 !important;
    position: relative !important;
    margin-right: 5px;
    fill: ${theme.colors.white}!important;
    & path {
      fill: ${theme.colors.white}!important;
    }
  }
`
export const Wrapper = styled.div`
  width: 100%;
  max-width: 500px;
  position: relative; ;
`

export const InputContent = styled.div`
  ${({ theme }) => css`
    input {
      border: 1px solid ${theme.colors.lightGray};
      display: block;
      width: 100%;
      height: 48px;
      font-size: 1rem;
      padding: 0.6rem;
      border-radius: 24px 24px;
      background: ${theme.colors.white};
      transition: 0.2s;
      padding-left: 20px;

      &:hover {
        outline: none;
        border-color: ${theme.colors.secondary};
        box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1);
      }
    }

    > button {
      /* position: absolute;
      top: 0;
      right: 0px;
      max-width: 0;
      height: 48px;
      background: #99000000;
      border: none; */

      /* > svg {
        position: absolute;
        left: 8px;
        top: 13px;
        path {
          fill: ${theme.colors.black};
        }
      } */
    }
  `}
`

export const filterContent = styled.div<filterContentProps>`
  ${({ theme, dropdownIsOpen }) => css`
    position: absolute;
    display: flex;
    align-items: center;
    margin: 0 8px;
    width: 100%;
    max-width: 130px;
    height: 24px;
    cursor: pointer;
    transition: filter ${theme.transition.default};

    &:hover {
      filter: brightness(0.5);
    }

    > svg {
      transform: ${dropdownIsOpen ? 'rotate(-90deg)' : 'rotate(180deg)'};
      margin-right: 4px;
      height: 6px;
      width: 10px;

      path {
        fill: ${theme.colors.black};
      }
    }

    > p {
      font-family: ${theme.font.montserrat};
      font-weight: ${theme.font.normal};
      font-size: 12px;
      color: ${theme.colors.primary};
    }
  `}
`

export const DropdownContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 30px;
    width: 100%;

    > button {
      display: flex;

      align-items: center;
      justify-content: center;
      max-width: 138px;
      height: 38px;
      font-size: ${theme.font.sizes.xxxsmall};
    }
  `}
`

export const DropdownContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;

  > div {
    flex: 1;
    margin-left: 20px;
  }

  ${media.lessThan('small')`
      > div {
        margin-left: 0;
      }
    `}
`
